export default __webpack_public_path__ + "static/bncff-web-site-1-d4e0dc3eebdeff1bc652815d3ed6b22d.jpg";